import script from "./detail_medsos.vue?vue&type=script&setup=true&lang=ts"
export * from "./detail_medsos.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__